import {CustomerMessageResponseBody} from '@dms/api/core';

import {parseDate} from 'shared/web';

import {MessageDayGroup} from '../types/MessageDayGroup';

function getDayKey(date: Date): string {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0'); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible
  const day = `${date.getDate()}`.padStart(2, '0');

  return `${year}-${month}-${day}`;
}

// Assumes `messages` are already sorted ascending (see sortMessagesChronologically).
export function groupMessagesByDay(messages: CustomerMessageResponseBody[]): MessageDayGroup[] {
  return messages.reduce<MessageDayGroup[]>((groups, message) => {
    const date = parseDate(message.createdAt);
    const dayKey = getDayKey(date);
    const lastGroup = groups.at(-1);

    if (lastGroup?.dayKey === dayKey) {
      lastGroup.messages.push(message);

      return groups;
    }

    const startOfDay = new Date(date.getFullYear(), date.getMonth(), date.getDate()); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible
    groups.push({dayKey, date: startOfDay, messages: [message]});

    return groups;
  }, []);
}
